import snakecaseKeys from 'snakecase-keys';
import { lowerCase } from 'lodash';
import { authorizedInstance as Rb } from '~/utils';

const convertDocType = v =>
  (v !== 'link' ? 'File' : 'Link');

const getSThreeLink = link =>
  Rb
    .get('get-s3-link', { params: { link } });

const service = {
  getSThreeLink,

  viewAttachment: ({ attachmentType, attachmentLink }) =>
    (attachmentType === 'link'
      ? window.open(attachmentLink, '_blank')
      : getSThreeLink(attachmentLink)
        .then(r => window.open(r.data.link, '_blank'))),

  createAttachment: (v) => {
    const p = {
      data: {
        ...v,
        docType: convertDocType(v.docType),
        fileType: lowerCase(convertDocType(v.docType)),
        file: v.file ? v.file.base64 : undefined,
        fileName: v.file ? v.file.title : undefined,
        links: {
          patient: {
            linkage: {
              type: 'patients',
              id: v.patient_id,
            },
          },
        },
      },
    };

    /* post because no api doesn't support put */
    return Rb
      .post('attachments', snakecaseKeys(p));
  },

  deleteAttachment: attachmentId =>
    Rb
      .delete(`attachements/${attachmentId}`),
};

export default service;
